'use client';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PropsWithClassname } from '@/app/types';
import { CategoryDetail } from '@/app/api';
import { Routes } from '@/app/enums';

import CategoriesBox from '@/app/components/CategoriesBox/CategoriesBox';

interface CollectionCategoriesBoxProps extends PropsWithClassname {
  categories: CategoryDetail[];
}

const CollectionCategoriesBox = ({ categories, className }: CollectionCategoriesBoxProps) => {
  const { t } = useTranslation();

  const allCategoriesLink = useMemo(() => {
    const baseUrl = process.env.NEXT_PUBLIC_REDIRECT_URL;

    if (baseUrl?.endsWith('/')) {
      return `${baseUrl}${Routes.ACTIVE_COLLECTIONS}`;
    }

    return `${baseUrl}/${Routes.ACTIVE_COLLECTIONS}`;
  }, []);

  return (
    <CategoriesBox
      heading={t('components.CollectionCategoriesBox.heading')}
      text={t('components.CollectionCategoriesBox.text')}
      buttonText={t('components.CollectionCategoriesBox.buttonText')}
      buttonLink={allCategoriesLink}
      categories={categories}
      className={className}
    />
  );
};

export default CollectionCategoriesBox;
